"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-shadow */
const react_1 = __importDefault(require("react"));
const UI_1 = require("~/components/UI");
const utils_1 = require("~/utils/utils");
const ItemPropertiesWidget_scss_1 = __importDefault(require("../ItemPropertiesWidget.scss"));
function ItemImagePropertiesList({ properties }) {
    if (!properties || !properties.length) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, properties.map((itemImage) => {
        return (react_1.default.createElement("div", { key: itemImage.name, className: ItemPropertiesWidget_scss_1.default['sub-item'] },
            react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default['sub-item-img'] },
                react_1.default.createElement(UI_1.Image, { src: (0, utils_1.formatAssetsURL)(itemImage.imageUrl) })),
            react_1.default.createElement("div", null, `#${itemImage.name}`),
            react_1.default.createElement("div", { className: ItemPropertiesWidget_scss_1.default.description }, `${itemImage.value}`)));
    })));
}
exports.default = ItemImagePropertiesList;
